import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var createTranslationsContext = function createTranslationsContext(_ref) {
  var defaultTranslations = _ref.defaultTranslations;
  var translationsContext = /*#__PURE__*/createContext(defaultTranslations);
  var Provider = translationsContext.Provider;
  var useTranslations = function useTranslations() {
    return useContext(translationsContext);
  };
  var TranslationsProvider = function TranslationsProvider(_ref2) {
    var children = _ref2.children,
      translations = _ref2.translations;
    return translations ? /*#__PURE__*/_jsx(Provider, {
      value: translations,
      children: children
    }) : children;
  };
  return {
    defaultTranslations: defaultTranslations,
    translationsContext: translationsContext,
    TranslationsProvider: TranslationsProvider,
    useTranslations: useTranslations
  };
};
//# sourceMappingURL=createTranslationsContext.js.map